import { render, staticRenderFns } from "./LuHead.vue?vue&type=template&id=32ce41e2"
import script from "./LuHead.vue?vue&type=script&lang=js"
export * from "./LuHead.vue?vue&type=script&lang=js"
import style0 from "./LuHead.vue?vue&type=style&index=0&id=32ce41e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports